<template>
  <div class="bg-white-shadow">
    <div class="row justify-content-center pt-4">
      <div class="col-12">
        <div class="row">
          <div class="col-6 col-md-2 text-center mt-5 mb-3" @click="handleEventClick(20)">
            <img src="@/assets/icons/1.png" alt="课题中心" class="img-fluid">
            <div class="font mt-2">课题中心</div>
          </div>
          <!-- 2.png - 奖项中心 -->
          <div class="col-6 col-md-2 text-center mt-5 mb-3" @click="handleEventClick(21)">
            <img src="@/assets/icons/2.png" alt="奖项中心" class="img-fluid">
            <div class="font mt-2">奖项中心</div>
          </div>
          <!-- 3.png - 赛事活动 -->
          <div class="col-6 col-md-2 text-center mt-5 mb-3" @click="handleEventClick(22)">
            <img src="@/assets/icons/3.png" alt="赛事活动" class="img-fluid">
            <div class="font mt-2">赛事活动</div>
          </div>
          <!-- 4.png - 学术资源 -->
          <!--
          <div class="col-6 col-md-2 text-center mt-5 mb-3">
            <img src="@/assets/icons/4.png" alt="学术资源" class="img-fluid">
            <div class="font mt-2">学术资源</div>
          </div>
          -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleEventClick(type) {
      this.$router.push({ 
        name: 'Events', 
        query: { type } 
      });
      window.scrollTo(0, 0);
    }
  }
};
</script>
